import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    useEffect(()=>{
        // console.log(window.nostoDisruptors);
        if(window.nostojs && window.nostoDisruptors){
            // console.log('OCPs are reloaded');
            window.nostojs(api => api.createRecommendationRequest()
                .setElements(window.nostoDisruptors)
                .load()
            )
        }
    }, [products])

    return (
        // ns-d-flex ns-flex-wrap style={loading ? "opacity: 0.3;" : ""}
        // data-product-grid="" data-id="template--19253617885421__product-grid-2698ce"
        <section 
            class="ns-products-container grid grid-cols-2 py-4 gap-x-[9px] gap-y-4 md:py-7 md:px-10 md:gap-x-2.5 md:gap-y-10 md:grid-cols-4"
            aria-label={`Product results grid with ${products.hits.length} products`}
            role="region"
        >
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </section>
    )
}

// version commented on October 2nd to adapt code for ADA compliance



// import Product from "./Product"
// import { useAppStateSelector } from "@nosto/preact"
// import { useEffect } from "preact/hooks"

// export default function Products() {
//     const {
//         products,
//         loading
//     } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

//     useEffect(()=>{
//         // console.log(window.nostoDisruptors);
//         if(window.nostojs && window.nostoDisruptors){
//             // console.log('OCPs are reloaded');
//             window.nostojs(api => api.createRecommendationRequest()
//                 .setElements(window.nostoDisruptors)
//                 .load()
//             )
//         }
//     }, [products])

//     return (
//         // ns-d-flex ns-flex-wrap style={loading ? "opacity: 0.3;" : ""}
//         // data-product-grid="" data-id="template--19253617885421__product-grid-2698ce"
//         <div class="ns-products-container grid grid-cols-2 py-4 gap-x-[9px] gap-y-4 md:py-7 md:px-10 md:gap-x-2.5 md:gap-y-10 md:grid-cols-4">
//             {products.hits.map((hit, index) => {
//                 return <Product product={hit} key={hit.productId || index} />
//             })}
//         </div>
//     )
// }
